<template>
  <header id="header" class="flex align-center">
    <svg @click.stop="toggleSidebar" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" class="menu-icon dspl-none dspl-block-m dspl-block-sm" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>
    <div class="flex align-center justify-space-between grow-1">
      <h2>{{ title }}</h2>
      <h2 v-if="isStaging" class="mode-disclaimer">Ambiente de pruebas</h2>
      <h3>{{ userName }}</h3>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoggedInHeader',
  computed: {
    ...mapGetters('user', [
      'userIsCompanyType'
    ]),
    ...mapGetters([
      'name',
      'billing_name'
    ]),
    title () {
      if (this.$route.meta.title) {
        return this.$route.meta.title
      } else {
        return 'Línea Exprés'
      }
    },
    userName () {
      if (this.userIsCompanyType) {
        return this.billing_name
      }

      return this.name
    },
    isStaging () {
      return process.env.VUE_APP_MODE === 'staging'
    }
  },
  methods: {
    toggleSidebar () {
      const sidebar = document.getElementById('sidebar')

      if (sidebar.classList.contains('active')) {
        setTimeout(() => {
          sidebar.classList.remove('active')
        }, 500)
        sidebar.classList.add('inactive')
      } else {
        sidebar.classList.remove('inactive')
        sidebar.classList.add('active')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#header {
  background-color: $blue;
  color: $white;
  border-radius: 0px 0px 0px 25px;
  padding: 0 2rem;
  position: sticky;
  top: 0;
  z-index: 2;
}

.mode-disclaimer {
  color: #f73e3e;
  text-decoration: underline;
}

@media screen and (max-width: 960px) {
  #header {
    padding: .75rem 1.5rem;
    border-radius: 0;
  }

  .menu-icon {
    width: 1.25rem;
    margin-right: 1.5rem;
  }

  h2, h3 {
    font-size: 1rem;
  }
}

</style>
